import { render, staticRenderFns } from "./mj-text.vue?vue&type=template&id=337c8cfb"
import script from "./mj-text.vue?vue&type=script&lang=ts"
export * from "./mj-text.vue?vue&type=script&lang=ts"
import style0 from "./mj-text.vue?vue&type=style&index=0&id=337c8cfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports